import useVuelidate from '@vuelidate/core';
import { mapActions, mapState } from 'vuex';

import store from '@/store';
import { SNACKBAR_TYPES, VERIFY_MAIL_TYPES } from '@/utils/constants';
import { ERROR_EMAIL_EXPIRED } from '@/utils/errorCodeList';
import {
  password,
  required,
  sameAsPassword,
} from '@/utils/validators';

export default {
  name: 'ResetPassword',
  setup() {
    return { v$: useVuelidate() };
  },
  data() {
    return {
      form: {
        confirmPassword: '',
        password: '',
      },
    };
  },
  computed: {
    ...mapState('user', {
      checkingToken: ({ checkingResetPasswordToken }) => checkingResetPasswordToken,
      updatingUser: ({ updatingUser }) => updatingUser,
    }),
    getPasswordMsg() {
      return this.hasErrorMsgs('password')
        ? this.getErrorMsgs('password') : '密碼長度必須8個字元以上，並且其中必須含英文字母及數字';
    },
  },
  async created() {
    const token = this.$route?.query?.confirmation_token;
    if (!token) {
      this.$snackbar({
        type: SNACKBAR_TYPES.ERROR,
        title: '找不到驗證碼',
        msg: '請確認您的重設密碼網址無誤並重試。',
      });
      this.$router.replace('/login');
      return;
    }

    try {
      await this.checkResetPasswordToken(token);
    } catch (error) {
      const { message, status } = error;
      const errorMessage = message ? `（錯誤：${message}）` : '';

      this.$snackbar({
        type: SNACKBAR_TYPES.ERROR,
        title: 'Token驗證失敗',
        msg: `請確認您的Token無誤並重試。${errorMessage}`,
      });

      if (status === ERROR_EMAIL_EXPIRED) {
        this.$router.replace({ name: 'SendVerifyEmail', params: { type: VERIFY_MAIL_TYPES.RESET_PASSWORD } });
      } else {
        this.$router.replace('/login');
      }
    }
  },
  beforeDestroy() {
    if (localStorage.getItem('_t')) {
      store.dispatch('user/USER_LOGOUT');
    }
  },
  methods: {
    ...mapActions('user', {
      checkResetPasswordToken: 'CHECK_RESET_PASSWORD_TOKEN',
      clearToken: 'CLEAR_RESET_PASSWORD_TOKEN',
      updateUser: 'UPDATE_USER',
    }),
    async confirm() {
      const valid = await this.v$.$validate();
      if (!valid) return;

      try {
        await this.updateUser({ password: this.form.password });
        this.$router.replace('/login');
        this.$snackbar({
          type: SNACKBAR_TYPES.SUCCESS,
          title: '完成重設密碼',
          msg: '密碼已重設完成，請直接登入。',
        });
      } catch (error) {
        const { message = '' } = error;
        this.$snackbar({
          type: SNACKBAR_TYPES.ERROR,
          title: '重設密碼失敗',
          msg: `重設密碼失敗，請稍後再試。${message}`,
        });
      }
    },
    getErrorMsgs(field) {
      return this.v$.form?.[field]?.$errors?.[0]?.$message;
    },
    hasErrorMsgs(field) {
      return this.v$.form?.[field]?.$errors?.length;
    },
  },
  validations() {
    return {
      form: {
        password: { required: required('密碼'), password },
        confirmPassword: { required: required('確認密碼'), sameAsPassword: sameAsPassword(() => this.form.password) },
      },
    };
  },
};
